<fgb-page-header [pageTitle]="'rewards.wallet.claimed.reward.title'" [showBalance]="false" [backButtonLink]="'/rewards/wallet'" />

<div class="container">
  <div class="pt-20 pb-20 d-none d-lg-block">
    <div class="glass-back-button" [routerLink]="'/rewards/wallet'">
      <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
    </div>
  </div>

  <div class="page-content">
    <h2 class="item-history-title font-page-heading font-size-20 mt-0 text-uppercase mb-0">
      {{ 'rewards.wallet.item.history.title' | translate : { fgbdefault: 'Item History' } }}
    </h2>

    @if (walletItemsClaimed$ | async; as claimedItems) {
      @if (claimedItems.length) {
        <fgbcl-rewards-wallet-redeemed-list [redeemedItems]="claimedItems" />
      } @else {
        <ng-container *ngTemplateOutlet="noWalletItems"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="noWalletItems"></ng-container>
    }
  </div>
</div>

<ng-template #noWalletItems>
  <div class="no-items-placeholder font-size-12 text-center">
    {{ 'claimed.rewards.placeholder.description' | translate }}
  </div>
</ng-template>
